// EqualHeight
// Sets multiple divs to the same height

$(document).ready(equalHeight);
$(window).on('load', equalHeight);
$(window).on('resize', equalHeight);

function equalHeight() {
    let groups = {};

    // generate groups by their groupId set by elements using equal-group
    $('[data-equal-group]').each(function () {
        let $this = $(this),
            groupId = $this.attr('data-equal-group');
        if (groupId in groups) {
            groups[groupId] = groups[groupId].add($this);
        } else {
            groups[groupId] = $this;
        }
    });

    // apply minHeight to each group
    $.each(groups, function () {
        let groupNr = $(this).attr('data-equal-group-nr');
        let groupUnset = $(this).attr('data-equal-group-unset');
        let groupBreak = $(this).attr('data-equal-group-break');
        let groupBreakNr = $(this).attr('data-equal-group-break-nr');

        if (groupNr !== undefined) {
            $(this).css('height', '').setHeight(parseInt(groupNr));
        } else {
            $(this).css('height', '').setHeight(0);
        }
        if (groupBreak !== undefined) {
            if (g_windowWidth <= groupBreak && groupBreakNr !== undefined) {
                $(this).css('height', '').setHeight(parseInt(groupBreakNr));
            }
        }
        if (groupUnset !== undefined) {
            if (g_windowWidth <= groupUnset) {
                $(this).css('height', '');
            }
        }
    });
}

$.fn.setHeight = function (setCount) {
    if (setCount === 0) {
        setCount = this.length;
    }
    for (let i = 0; i < this.length; i += setCount) {
        let curSet = this.slice(i, i + setCount)
        let height = 0;

        curSet.each(function () {
            height = Math.max(height, Math.ceil($(this).outerHeight()));
        }).css('height', height);
    }
    return this;
};
